import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "mn", setLang: () => {}, t: (mn) => mn });

const DICT = {
  nav_home: { mn: "Нүүр", en: "Home" },
  nav_gallery: { mn: "Галлерей", en: "Gallery" },
  nav_booking: { mn: "Захиалга", en: "Booking" },
  nav_contact: { mn: "Холбоо барих", en: "Contact" },
  book_now: { mn: "Захиалах", en: "Book now" },
  explore: { mn: "Үзэх", en: "Explore" },
  learn_more: { mn: "Дэлгэрэнгүй", en: "Learn more" },
  features_title: { mn: "Таны амралтыг бүрдүүлэх зүйлс", en: "Things to make your stay cozy" },
  houses_title: { mn: "Манай байшингууд", en: "Our tiny houses" },
  gallery_title: { mn: "Галлерей", en: "Gallery" },
  gallery_sub: { mn: "Ой модны дундах тогтсон агшингууд", en: "Moments captured among the pines" },
  booking_title: { mn: "Захиалга хийх", en: "Reserve your stay" },
  booking_sub: {
    mn: "3 сарын хүртээмжийн хуанли, SocialPay-ээр төлбөрөө хийж баталгаажуулна уу",
    en: "3-month availability calendar, pay via SocialPay to confirm",
  },
  choose_house: { mn: "Байшингаа сонгох", en: "Choose a tiny house" },
  check_in: { mn: "Ирэх өдөр", en: "Check-in" },
  check_out: { mn: "Явах өдөр", en: "Check-out" },
  addons: { mn: "Нэмэлт үйлчилгээ", en: "Add-ons" },
  your_name: { mn: "Нэр", en: "Full name" },
  your_phone: { mn: "Утас", en: "Phone" },
  transaction_text: { mn: "Гүйлгээний утга / лавлагаа", en: "Transaction reference" },
  note: { mn: "Нэмэлт тэмдэглэл (заавал биш)", en: "Additional note (optional)" },
  submit_booking: { mn: "Захиалгыг илгээх", en: "Submit booking" },
  payment_title: { mn: "Төлбөр - Golomt SocialPay", en: "Payment - Golomt SocialPay" },
  payment_desc: {
    mn: "SocialPay апп-аа ашиглан доорх QR кодыг уншуулна уу. Админ гүйлгээг шалгаад таны захиалгыг баталгаажуулна.",
    en: "Scan the QR code below with SocialPay. Admin will verify the transaction and approve your booking.",
  },
  contact_title: { mn: "Холбоо барих", en: "Get in touch" },
  contact_sub: { mn: "Танд туслахдаа бид баяртай байна", en: "We’d love to hear from you" },
  send_msg: { mn: "Илгээх", en: "Send message" },
  message: { mn: "Зурвас", en: "Message" },
  email: { mn: "Имэйл", en: "Email" },
  booking_success: {
    mn: "Таны захиалгыг хүлээн авлаа. Админ удахгүй баталгаажуулна.",
    en: "Your booking has been received. Admin will confirm shortly.",
  },
  contact_success: { mn: "Зурвас амжилттай илгээгдлээ.", en: "Message sent successfully." },
  available: { mn: "Сул", en: "Available" },
  booked: { mn: "Захиалагдсан", en: "Booked" },
  selected: { mn: "Сонгогдсон", en: "Selected" },
  nights: { mn: "шөнө", en: "nights" },
  total: { mn: "Нийт", en: "Total" },
  from: { mn: "Нэг шөнийн үнэ", en: "From" },
  per_night: { mn: "/ шөнө", en: "/ night" },
  capacity: { mn: "хүн", en: "guests" },
  admin_login: { mn: "Админ нэвтрэх", en: "Admin login" },
  password: { mn: "Нууц үг", en: "Password" },
  login: { mn: "Нэвтрэх", en: "Login" },
  logout: { mn: "Гарах", en: "Logout" },
  status_pending: { mn: "Хүлээгдэж буй", en: "Pending" },
  status_approved: { mn: "Баталгаажсан", en: "Approved" },
  status_rejected: { mn: "Татгалзсан", en: "Rejected" },
  location: { mn: "Байршил", en: "Location" },
  phone: { mn: "Утас", en: "Phone" },
  view_image: { mn: "Зургийг үзэх", en: "View image" },
  prev: { mn: "Өмнөх", en: "Previous" },
  next: { mn: "Дараах", en: "Next" },
  close: { mn: "Хаах", en: "Close" },
  play: { mn: "Тоглуулах", en: "Play" },
  pause: { mn: "Зогсоох", en: "Pause" },
  image_of: { mn: "/", en: "of" },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("minimodu_lang") || "mn");
  useEffect(() => {
    localStorage.setItem("minimodu_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => {
    const entry = DICT[key];
    if (!entry) return key;
    return entry[lang] || entry.mn;
  };
  const pick = (obj, fieldBase) => {
    if (!obj) return "";
    const k = `${fieldBase}_${lang}`;
    return obj[k] || obj[`${fieldBase}_mn`] || obj[`${fieldBase}_en`] || "";
  };
  return (
    <LangContext.Provider value={{ lang, setLang, t, pick }}>{children}</LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
